module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Light.e57a43e.woff";